import React, { useState, useEffect } from "react";
import { Form, FormGroup, Label, Input, Button, Row, Col, InputGroup, InputGroupText } from "reactstrap";
import Session from '../auth/Session';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const UserForm = ({ apiBaseUrl, user, roles, onSuccess, onCancel }) => {
    const [userRoles, setUserRoles] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [signinFailed, setSigninFailed] = useState(false);

    useEffect(() => {
        getUserRoles();
    }, []);

    const [formData, setFormData] = useState(user || {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        officePhone: "",
        ext: "",
        homePhone: "",
        mobilePhone: "",
        active: true,
    });

    const getUserRoles = async () => {
        const token = await Session.getToken();
        const url = `${apiBaseUrl}/api/users/${user.id}/roles`;

        const response = await fetch(url, {
            method: 'GET',
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` }
        });

        if (response.ok) {
            let data = await response.json();
            setUserRoles(data);
        }
    }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;

        if (checked) {
            // Add the value to the array if checked
            setUserRoles(prevUserRoles => [...prevUserRoles, value]);
        } else {
            // Remove the value from the array if unchecked
            setUserRoles(prevUserRoles => prevUserRoles.filter(item => item !== value));
        }
    };

    useEffect(() => {
        console.log(`user roles: ${JSON.stringify(userRoles)}`);
    }, [userRoles]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const method = user ? "PUT" : "POST";
        const url = user
            ? `${apiBaseUrl}/api/users/${user.id}`
            : `${apiBaseUrl}/api/users`;

        let data = {
            ...formData,
            roles: userRoles
        };
        const token = await Session.getToken();

        const response = await fetch(url, {
            method,
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
            body: JSON.stringify(data),
        });

        if (response.ok) onSuccess();
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Row>
                <Col md={6}>
                    <FormGroup>
                        <Label>First Name</Label>
                        <Input name="firstName" value={formData.firstName} onChange={handleChange} />
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label>Last Name</Label>
                        <Input name="lastName" value={formData.lastName} onChange={handleChange} />
                    </FormGroup>
                </Col>
            </Row>
            <FormGroup>
                <Label>Email</Label>
                <Input name="email" value={formData.email} onChange={handleChange} />
            </FormGroup>
            <FormGroup>
                <Label>Mobile Phone</Label>
                <Input name="mobilePhone" value={formData.mobilePhone} onChange={handleChange} />
            </FormGroup>
            <FormGroup>
                <Label>Set Password</Label>
                <InputGroup>
                    <Input
                        id="password"
                        name="password"
                        type={showPassword ? 'text' : 'password'}
                        className='form-control'
                        value={formData.password}
                        onChange={handleChange}
                        placeholder='Password'
                    />
                    <InputGroupText
                        role="button"
                        onClick={() => {
                            setShowPassword(!showPassword);
                        }}
                    >
                        {showPassword ? (
                            <FaEyeSlash className="password-eye" />
                        ) : (
                            <FaEye className="password-eye" />
                        )}

                    </InputGroupText>
                </InputGroup>
            </FormGroup>
            <FormGroup check>
                <Input type="checkbox" name="active" checked={formData.active} onChange={handleChange} />
                <Label check>Active</Label>
            </FormGroup>
            <Row>
                <Col md={12}>
                    {userRoles && roles.map((role) => (
                        <>
                            <FormGroup check inline key={role.id} checked={userRoles ? userRoles.includes(role.name) : false}>
                                <Input
                                    type="checkbox"
                                    value={role.name}
                                    checked={userRoles.includes(role.name)}
                                    onChange={handleCheckboxChange}
                                />
                                <Label check>{role.name}</Label>
                            </FormGroup>
                        </>
                    )
                    )}
                </Col>
            </Row>

            <div className="mt-3 d-flex justify-content-end gap-2">
                <Button color="secondary" onClick={onCancel}>Cancel</Button>
                <Button color="primary" type="submit">Save</Button>
            </div>
        </Form>
    );
};

export default UserForm;
